import { createContext } from 'react';

export const CategoricalBarChartLoading = createContext<boolean | undefined>(
  undefined,
);

CategoricalBarChartLoading['displayName'] = 'CategoricalBarChartLoading';
